export default __webpack_public_path__ + "static/Денежный поток 303+404_6-cc6e2362669dccec548eb5e109615119.jpg";